import Needle from './Needle'
import SelectionFrame from './SelectionFrame'
import { constructProxyUrl } from '@/utils/proxy'
import { Play, Pause, Volume2, VolumeX } from 'lucide-react'

const Timeline = ({
    togglePlay,
    isPlaying,
    toggleMute,
    isMuted,
    handleMouseDown,
    currentTime,
    trimStart,
    trimEnd,
    frames,
    timelineRef,
    handleTimelineClick,
}) => {
    return (
        <div className="tw:relative tw:mt-6">
            <div className="tw:flex tw:items-center tw:gap-3">
                <button
                    onClick={togglePlay}
                    className="tw:text-blue-300 tw:p-0 tw:bg-transparent tw:border-none tw:text-2xl tw:cursor-pointer"
                >
                    {isPlaying ? <Pause size={24} /> : <Play size={24} />}
                </button>

                <div className="tw:flex tw:w-full tw:bg-black tw:px-8">
                    {/* Timeline */}
                    <div
                        ref={timelineRef}
                        className="tw:flex-1 tw:relative tw:h-[36px] tw:cursor-pointer tw:flex tw:items-center tw:bg-transparent"
                        onClick={handleTimelineClick}
                    >
                        {/* Frame Thumbnails Background */}
                        <div className="tw:absolute tw:top-0 tw:left-0 tw:w-full tw:h-8 tw:flex tw:mt-0.5">
                            {frames.map((frame) => (
                                <img
                                    key={frame.id}
                                    src={constructProxyUrl(frame.thumbnail)}
                                    alt={`Frame ${frame.id}`}
                                    className="tw:h-full tw:object-cover tw:flex-1 tw:!pointer-events-none tw:select-none tw:cursor-default"
                                    style={{
                                        width: `${100 / frames.length}%`,
                                    }}
                                />
                            ))}
                        </div>

                        {/* Trim Overlay */}
                        <div
                            className="tw:absolute tw:top-0 tw:left-0 tw:h-full tw:bg-black tw:opacity-30"
                            style={{
                                width: `${trimStart}%`,
                            }}
                        />
                        <div
                            className="tw:absolute tw:top-0 tw:right-0 tw:h-full tw:bg-black tw:opacity-40"
                            style={{
                                width: `${100 - trimEnd}%`,
                            }}
                        />

                        <SelectionFrame trimStart={trimStart} trimEnd={trimEnd} handleMouseDown={handleMouseDown} />

                        <Needle currentTime={currentTime} handleMouseDown={handleMouseDown} />
                    </div>
                </div>
                {/* Mute/Unmute Button */}
                <button
                    onClick={toggleMute}
                    className="tw:text-blue-300 tw:p-0 tw:bg-transparent tw:border-none tw:text-2xl tw:cursor-pointer"
                >
                    {isMuted ? <VolumeX size={24} /> : <Volume2 size={24} />}
                </button>
            </div>
        </div>
    )
}

export default Timeline
